import Vuetify from 'vuetify';
import { VuetifyTheme } from '../utils/ui/vuetify.theme';
export { Vuetify, VuetifyTheme };
